<app-page-body>

  <!-- header -->
  <app-page-header [title]="'pages.organizationTransactions.resellerTransactionsDetailTitle' | translate"  [isForm]="true" (onBack)="onClose()" [showRefreshBtn]="false">
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">

    <app-base-organization-transactions-detail
    [TypeCreditChangesEnumValues]="TypeCreditChangesEnumValues"
    [TypeTransactionsEnumValues]="TypeTransactionsEnumValues"
    [model]="model"></app-base-organization-transactions-detail>

  </div>


</app-page-body>